import { render, staticRenderFns } from "./SupplierQualityForm.vue?vue&type=template&id=06340f0c&scoped=true"
import script from "./SupplierQualityForm.vue?vue&type=script&lang=js"
export * from "./SupplierQualityForm.vue?vue&type=script&lang=js"
import style0 from "./SupplierQualityForm.vue?vue&type=style&index=0&id=06340f0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06340f0c",
  null
  
)

export default component.exports